import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {environment} from '../../../environments/environment';
import {Lens} from '../../lenses/shared/model/lens';
import {UserApiService} from './user-api.service';

@Injectable({
  providedIn: 'root',
})
export class LensesApiService {
  private userApiService = inject(UserApiService);
  constructor(private http: HttpClient) {}

  private get url() {
    return `${environment.apiUrl}/lens`;
  }

  public get(): Observable<Lens[]> {
    return this.http.get<Lens[]>(this.url);
  }

  public getSingle(id: string): Observable<Lens[]> {
    return this.http.get<Lens[]>(`${this.url}/${id}`);
  }

  public getUserLens(): Observable<Lens> {
    return this.userApiService.getActiveUser().pipe(map(user => user.lens));
  }

  public create(lensTitle: string): Observable<Lens> {
    return this.http.post<Lens>(`${this.url}`, {title: lensTitle});
  }

  public update(lens: Lens): Observable<Lens> {
    return this.http.put<Lens>(`${this.url}/${lens._id}`, lens);
  }

  public delete(id: string): Observable<Object> {
    return this.http.delete<Lens[]>(`${this.url}/${id}`);
  }
}
